import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import './Capa.css'

function Capa(props) {
    return (
        <div className='class-capa'>
            {(props.title)&&
            <div className='class-title'>
                <Typography variant="button" display="block" gutterBottom>{props.title}</Typography>
            </div>}


            {props.children}

            <hr />
            <section className='class-button'>
                <Button variant="contained" type="submit" onClick={props.onAceptar}>Aceptar</Button>
                <Button variant="outlined" onClick={props.onCancel}>Cancelar</Button>
            </section>
        </div>
    );
}

export default Capa;

